import { render } from "./MethodButton.vue?vue&type=template&id=7ed74101&lang=pug"
import script from "./MethodButton.vue?vue&type=script&lang=js"
export * from "./MethodButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__